import React from 'react';
import { Label } from '@nooz-optics/nooz-components-lib';
import { availableCountries } from './availableCountries';

export const NativeCountrySelect = (props) => {
  const { label, type, name, placeholder, color, size, onChange, register } =
    props;

  return (
    <div className='w-full lg:items-center lg:flex'>
      <div className='w-full'>
        {label && (
          <label htmlFor={name}>
            <Label {...label} />
          </label>
        )}
        <select
          {...props}
          onChange={onChange}
          style={{ backgroundColor: type === 'outlined' && 'transparent' }}
          className='w-full mt-1 relative rounded-md shadow-sm'
          {...(register && register(name))}>
          {placeholder && (
            <option
              value=''
              selected>
              {placeholder.text}
            </option>
          )}
          {availableCountries.map((country) => (
            <option value={country['ISO (3)']}>{country.Country}</option>
          ))}
        </select>
      </div>
    </div>
  );
};
